import { render, staticRenderFns } from "./KitchenOrder.vue?vue&type=template&id=3fca6712&"
import script from "./KitchenOrder.vue?vue&type=script&lang=js&"
export * from "./KitchenOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports